import * as React from "react";
import { CloseBtn } from "../../../assets/svg/CloseBtn";
import { IdStyles } from "../../../less/IdStyles";
export var ModalButtonClose = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (React.createElement("div", { className: className + " " + IdStyles.ModalButtonClose },
        React.createElement(CloseBtn, { className: "svg-button " + IdStyles.ModalButtonClose, onClick: onClick })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ModalButtonClose.tsx
// module id = 203
// module chunks = 3